// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const abn: CountryValidator<"AU"> = createValidator(
  "au.abn",
  12,
);

export default abn;
export const compact = abn.compact;
export const format = abn.format;
export const validate = abn.validate;
export const generate = (): string =>
  abn.generate?.() ??
  (() => {
    throw new Error(
      "Validator au.abn cannot generate values",
    );
  })();
